// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__63rsY","toggle":"styles_toggle__2Y-SX","preview":"styles_preview__1aVMM"};